import React from "react";
import { cx } from "../../utils/classNames";

export function Switch({ checked, onChange, className, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className={cx("switch", checked && "is-on", className)}
      onClick={() => onChange?.(!checked)}
    >
      <span className="switch-handle" />
    </button>
  );
}

export default Switch;
